import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const DashboardPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Dashboard,
  }))
);

export function DashboardContainer() {
  return <LazyLoadComponent Component={<DashboardPage />} />;
}
